import { useCOISentLogs } from '../../../../models/coi'
import { COISentLogTable } from './COISentLogTable'

export function COISentLogTab({ orgId }: { orgId?: string }) {
  const { logs, isLoading } = useCOISentLogs(undefined, orgId)

  return <COISentLogTable logs={logs} isLoading={isLoading} orgId={orgId} />
}
